"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ButtonLink = require("./ButtonLink");
Object.keys(_ButtonLink).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ButtonLink[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ButtonLink[key];
    }
  });
});